// Registro único de Nunito para react-pdf (regla 10.275). react-pdf/fontkit no lee woff2, por eso
// se usan los .woff que trae @fontsource/nunito en vez de los .css/.woff2 que consume la web.
// Única excepción permitida a "ningún componente nombra una familia": el resto de los PDFs
// importan PDF_FONT_FAMILY de acá, nunca escriben "Nunito" literal.
import nunitoItalic from "@fontsource/nunito/files/nunito-latin-400-italic.woff";
import nunitoRegular from "@fontsource/nunito/files/nunito-latin-400-normal.woff";
import nunitoBoldItalic from "@fontsource/nunito/files/nunito-latin-700-italic.woff";
import nunitoBold from "@fontsource/nunito/files/nunito-latin-700-normal.woff";
import { Font } from "@react-pdf/renderer";

export const PDF_FONT_FAMILY = "Nunito";

Font.register({
  family: PDF_FONT_FAMILY,
  fonts: [
    { src: nunitoRegular },
    { src: nunitoBold, fontWeight: "bold" },
    { src: nunitoItalic, fontStyle: "italic" },
    { src: nunitoBoldItalic, fontWeight: "bold", fontStyle: "italic" },
  ],
});
